module.exports = __webpack_public_path__ + "img/6074.42458a85.jpg";